<template>
    <div
        class="ql-cue-layer-picker-content cue-header-layer-title"
        @contextmenu="preventContextFunc($event)"
    >
        <md-menu v-if="locked || !editable" class="ql-button-container" @open="onMenuOpen">
            <md-button md-menu-trigger class="ql-cue-layer-picker-button" :class="{'name-hidden': headerBox.layerName === false}" :style="layerTitleStyle()">
                <md-icon :style="layerTitleIconStyle()">more_vert</md-icon><span v-show="headerBox.layerName !== false">{{currentLayer.title}}</span>
                <md-tooltip md-direction="top">Left click to modify cue, right click to add work note</md-tooltip>
            </md-button>
        </md-menu>
        <md-menu v-else md-size="4" ref="layerMenu" :md-close-on-select="false" md-align-trigger :md-offset-x="menuOffsetStyleX()" :md-offset-y="menuOffsetStyleY()" @open="onMenuOpen" @close="resetPageDraft">
            <md-button md-menu-trigger class="ql-cue-layer-picker-button" :class="{'name-hidden': headerBox.layerName === false}" :style="layerTitleStyle()">
                <md-icon :style="layerTitleIconStyle()">more_vert</md-icon><span v-show="headerBox.layerName !== false">{{currentLayer.title}}</span>
                <md-tooltip md-direction="top">Left click to modify cue, right click to add work note</md-tooltip>
            </md-button>
            <md-menu-content class="ql-cue-menu-content" @blur="$value => updateCueStatus()">
                <md-menu-item @selected="deleteCueMarker()">
                    <md-icon>delete</md-icon><span>Delete Cue</span>
                </md-menu-item>
                <li class="md-list-item">
                    <hr/>
                </li>
                <md-menu-item disabled><span>Change Page:</span></md-menu-item>
                <li class="md-list-item md-menu-item change-page">
                    <div class="md-list-item-container">
                        <div class="md-list-item-content">
                            <div style="display: flex; align-items: center;">
                                <md-button class="md-icon-button md-raised md-dense" v-bind:disabled="!canPageDown" v-on:click="pageDown"><md-icon>keyboard_arrow_left</md-icon></md-button>
                                <div class="page-number-container">
                                    <input type="text" ref="input_page_number" v-model="pageDraft" class="input_page_number" @keyup.enter="change_page_number" @input="pageError = ''" v-on:keydown.left="ignoreKeydown" v-on:keydown.right="ignoreKeydown" />
                                        / {{ lastPageLabel }}
                                </div>
                                <md-button class="md-icon-button md-raised md-dense" v-bind:disabled="!canPageUp" v-on:click="pageUp"><md-icon>keyboard_arrow_right</md-icon></md-button>
                            </div>
                            <span class="page-number-error" v-if="pageError">{{ pageError }}</span>
                        </div>
                        <md-button class="md-icon-button change-page-done" v-on:click="change_page_number">Done</md-button>
                    </div>
                </li>
                <li class="md-list-item">
                    <hr/>
                </li>
                <md-menu-item disabled><span>Change Layer:</span></md-menu-item>
                <md-menu-item v-for="layer in layers" :key="layer.id" @selected="selectLayer(layer.id)" class="ql-cue-layer-picker-wrapper">
                    <span class="ql-cue-layer-picker" :style="style(layer)"></span>
                    <span class="ql-cue-layer-picker-option">{{layer.title}}</span>
                </md-menu-item>
                <li class="md-list-item">
                    <hr/>
                </li>
                <li class="md-list-item md-menu-item visible-in-cue">
                    <div class="md-list-item-container">
                        <div class="md-list-item-content ql-cue-menu-list-item-content">
                            <span>Visible in cue:</span>
                            <div class="md-list-item-radio-options">
                                <div class="headerBoxOption" :class="{'headerBoxOptionMarked': headerBox.layerName !== false}" @click="changeHeaderBoxLayerName">
                                    <md-icon v-show="headerBox.layerName === false">check_box_outline_blank</md-icon>
                                    <md-icon v-show="headerBox.layerName !== false">check_box</md-icon>
                                    <span>Layer Name</span>
                                </div>
                                <div class="headerBoxOption" :class="{'headerBoxOptionMarked': headerBox.title}" @click="changeHeaderBoxTitle">
                                    <md-icon v-show="!headerBox.title">check_box_outline_blank</md-icon>
                                    <md-icon v-show="headerBox.title">check_box</md-icon>
                                    <span>Number/Title</span>
                                </div>
                                <div class="headerBoxOption" :class="{'headerBoxOptionMarked': headerBox.label}" @click="changeHeaderBoxLabel">
                                    <md-icon v-show="!headerBox.label">check_box_outline_blank</md-icon>
                                    <md-icon v-show="headerBox.label">check_box</md-icon>
                                    <span>Label</span>
                                </div>
                                <div class="headerBoxOption" :class="{'headerBoxOptionMarked': headerBox.time}" @click="changeHeaderBoxTime">
                                    <md-icon v-show="!headerBox.time">check_box_outline_blank</md-icon>
                                    <md-icon v-show="headerBox.time">check_box</md-icon>
                                    <span>Time</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="md-list-item">
                    <hr/>
                </li>
                <li class="md-list-item md-menu-item cue-size">
                    <div class="md-list-item-container">
                        <div class="md-list-item-content">
                            <span>Cue Size:</span>
                            <vue-slider v-model="cueTitleFontSize" :min="8" :max="24" @change="changeTitleFontSize"></vue-slider>
                        </div>
                    </div>
                </li>
                <li class="md-list-item md-menu-item">
                    <div class="md-list-item-container">
                        <div class="md-list-item-content">
                            <span>Cue Line Opacity:</span>
                            <vue-slider v-model="cueLineOpacity" @change="changeLineOpacity"></vue-slider>
                        </div>
                    </div>
                </li>
                <md-menu-item @selected="restoreDefault()">
                    <span style="color: #5ecfdf;">Restore Default</span>
                </md-menu-item>
                <li class="md-list-item">
                    <hr/>
                </li>
                <li class="md-list-item md-menu-item cue-marker">
                    <div class="md-list-item-container">
                        <div class="md-list-item-content ql-cue-menu-list-item-content">
                            <span>Cue Marker:</span>
                            <div class="md-list-item-radio-options">
                                <div><md-radio v-model="cue.type" mdValue="position" class="md-primary" @change="changeCueMarker"> Line</md-radio></div>
                                <div><md-radio v-model="cue.type" mdValue="selection" class="md-primary" @change="changeCueMarker"> Resizable Box</md-radio></div>
                            </div>
                            <div v-if="cue.type === 'selection'">
                                <span>Cue Box Opacity:</span>
                                <vue-slider v-model="cueBoxOpacity" @change="changeBoxOpacity"></vue-slider>
                            </div>
                        </div>
                    </div>
                </li>
                <md-menu-item v-if="cue.type === 'selection'" @selected="restoreDefaultCueMarker()">
                    <span style="color: #5ecfdf;">Restore Default</span>
                </md-menu-item>
            </md-menu-content>
        </md-menu>
    </div>
    </template>
    
    <script>
    import { mapGetters } from 'vuex';
    import VueSlider from 'vue-slider-component';
    import { resolvePageLabel, labelForPage, isValidPageNumber } from '@/lib/cue-page';
    
    const ProjectCuesLayerPicker = {
        name: 'projectCuesLayerPicker',
        props: ['cue', 'currentLayer', 'editable', 'locked', 'titleFontSize', 'headerBox', 'layerCueLineOpacity', 'layerCueBoxOpacity', 'svgTrueHeight'],
        data: function() {  
            return {
                move_cue_to: Number(this.$props.cue.pageNumber),
                // What is in the page box: a PRINTED label, edited freely. Resolved only on Done.
                pageDraft: '',
                pageError: '',
                cueTitleFontSize: this.$props.titleFontSize,
                cueLineOpacity: this.$props.layerCueLineOpacity,
                cueBoxOpacity: this.$props.layerCueBoxOpacity,
                changeTitleFontSizeTimer: null,
                changeLineOpacityTimer: null,
                changeBoxOpacityTimer: null
            };
        },
        computed: {
            ...mapGetters({
                selectedScale: 'selectedScale',
                userProjectData: 'userProjectData',
                layers: 'validCueLayers',
                project: 'project',
                currentVersion: 'currentVersion',
                projectTotalPages: 'projectTotalPages'
            }),
            canPageDown() {
                if (this.move_cue_to > 1) {
                    return true;
                }
                return false;
            },
            canPageUp() {
                if (this.move_cue_to < this.totalPages) {
                    return true;
                }
                return false;
            },
            versionID: function() {
                return this.currentVersion ? this.currentVersion.id : '';
            },
            // Printed labels in physical order, for the version being viewed or the live project.
            pageLabels: function() {
                const source = this.versionID ? this.currentVersion : this.project;
                return (source && Array.isArray(source.pdfPageNumbers)) ? source.pdfPageNumbers : [];
            },
            lastPageLabel: function() {
                return labelForPage(this.pageLabels, this.pageLabels.length);
            },
            totalPages: function() {
                if (this.versionID) {
                    return this.projectTotalPages || 0;
                }
                
                return (this.project && Array.isArray(this.project.pdfPageNumbers)) 
                    ? this.project.pdfPageNumbers.length 
                    : 0;
            }
        },
        watch: {
            // Moved underneath us (another user, a page insert/delete): show the real page.
            'cue.pageNumber': function() {
                this.resetPageDraft();
            },
            'cue.titleFontSize': function() {
                this.prefillCueTitleFontSize();
            },
            titleFontSize: function() {
                this.prefillCueTitleFontSize();
            },
            'cue.lineOpacity': function() {
                this.prefillCueLineOpacity();
            },
            layerCueLineOpacity: function() {
                this.prefillCueLineOpacity();
            },
            'cue.boxOpacity': function() {
                this.prefillCueBoxOpacity();
            },
            layerCueBoxOpacity: function() {
                this.prefillCueBoxOpacity();
            }
        },
        methods: {
            onMenuOpen() {
                this.resetPageDraft();
                const menuContent = document.querySelector('.md-menu-content');
                const cueMenuContent = document.querySelector('.ql-cue-menu-content');
                menuContent.style.removeProperty('max-height');
    
                const cuePlaceHeight = (Number(((this.cueTitleFontSize)) + 5).toFixed(5)) * this.selectedScale;
                let marginTopPos = document.querySelector('.ql-cue-' + this.cue.id);
    
                marginTopPos = window.getComputedStyle(marginTopPos).top;
                marginTopPos = parseFloat(marginTopPos.replace('px', ''));
    
                marginTopPos += (cuePlaceHeight / this.selectedScale);
    
                const layerClientHeight = cueMenuContent.clientHeight;
                let topOfTheMenuPos = 0;
    
                if (this.svgTrueHeight < (this.cue.lineY2 + layerClientHeight)) {
                    if ((this.svgTrueHeight - 100) > marginTopPos) {
                        marginTopPos += 4;
                        topOfTheMenuPos = this.svgTrueHeight - this.cue.lineY2;
                        menuContent.style.setProperty('max-height', `${topOfTheMenuPos}px`, 'important');
                    } else {
                        marginTopPos -= layerClientHeight;
                    }
                } else {
                    marginTopPos += 4;
                }
    
                if (cuePlaceHeight < 14) {
                    marginTopPos += (14 - this.cueTitleFontSize);
                }
                if (cuePlaceHeight > 14) {
                    marginTopPos -= (this.cueTitleFontSize - 14);
                }
                cueMenuContent.style.marginTop = `${Math.abs(marginTopPos)}px`;
            },
            style(layer) {
                const val = 'background-color: ' + layer.color + ' !important;';
                return val;
            },
            open() {
                this.$refs.layerMenu.open();
            },
            close() {
                this.$refs.layerMenu.close();
            },
            selectLayer(layer) {
                this.$emit('selectLayer', layer);
            },
            ignoreKeydown(e) {
                e.stopPropagation();
            },
            // The box always opens (and reopens) on the cue's REAL page, never a stale draft.
            resetPageDraft() {
                this.move_cue_to = Number(this.cue.pageNumber);
                this.pageDraft = labelForPage(this.pageLabels, this.move_cue_to) || String(this.cue.pageNumber || '');
                this.pageError = '';
            },
            // Done and Enter. The draft is a printed label; anything that is not one is
            // refused with a message and NOTHING is written (see lib/cue-page.js).
            change_page_number() {
                const draft = String(this.pageDraft == null ? '' : this.pageDraft).trim();
                const target = resolvePageLabel(draft, this.pageLabels);
                if (!target || !isValidPageNumber(target, this.totalPages || undefined)) {
                    this.pageError = `No page "${draft}" in this production.`;
                    return;
                }
                this.pageError = '';
                this.move_cue_to = target;
                if (target !== Number(this.cue.pageNumber)) {
                    this.cue.pageNumber = target;
                    this.$store.dispatch('updateCue', this.cue).catch(e => console.error(e));
                }
                this.close();
            },
            changeCueMarker() {
                this.cue.type = this.cue.type === 'position' ? 'selection' : 'position';
                if (this.cue.type === 'position') {
                    delete this.cue.lineX1;
                    delete this.cue.lineX2;
                    delete this.cue.lineY1;
                    delete this.cue.lineY2;
                    delete this.cue.offsetX;
                    delete this.cue.offsetY;
                    this.cue.width = 30;
                    this.cue.height = 30;
                } else {
                    this.cue.width = 60;
                    this.cue.height = 15;
                }
                this.$store.dispatch('updateCue', this.cue);
            },
            updateCueStatus() {
                this.$emit('updateStatus', {
                    isEditing: false,
                    isEditingDescription: false
                });
            },
            prefillCueTitleFontSize() {
                // this.cueTitleFontSize = layers[this.layer.id].titleFontSize;
                this.cueTitleFontSize = this.$props.titleFontSize;
            },
            prefillCueLineOpacity() {
                // cueLineOpacity : default 30
                // this.cueLineOpacity = 30;
                // if (this.$props.currentLayer.lineOpacity !== undefined) {
                //     this.cueLineOpacity = this.$props.currentLayer.lineOpacity;
                // }
                // if (this.$props.cue.lineOpacity !== undefined) {
                //     this.cueLineOpacity = this.$props.cue.lineOpacity;
                // }
                this.cueLineOpacity = this.$props.layerCueLineOpacity;
            },
            prefillCueBoxOpacity() {
                // cueBoxOpacity : default 20
                // this.cueBoxOpacity = 20;
                // if (this.$props.currentLayer.boxOpacity !== undefined) {
                //     this.cueBoxOpacity = this.$props.currentLayer.boxOpacity;
                // }
                // if (this.$props.cue.boxOpacity !== undefined) {
                //     this.cueBoxOpacity = this.$props.cue.boxOpacity;
                // }
                this.cueBoxOpacity = this.$props.layerCueBoxOpacity;
            },
            changeTitleFontSize() {
                if (this.changeTitleFontSizeTimer) {
                    clearTimeout(this.changeTitleFontSizeTimer);
                }
                this.changeTitleFontSizeTimer = setTimeout(() => {
                    // this.cue.titleFontSize = this.cueTitleFontSize;
                    // this.$store.dispatch('updateCue', this.cue);
                    this.$store.dispatch('addCueTitleFontSize', {
                        id: this.cue.id,
                        titleFontSize: this.cueTitleFontSize
                    });
                    this.changeTitleFontSizeTimer = null;
                }, 500);
            },
            changeLineOpacity() {
                if (this.changeLineOpacityTimer) {
                    clearTimeout(this.changeLineOpacityTimer);
                }
                this.changeLineOpacityTimer = setTimeout(() => {
                    this.$store.dispatch('addCueLineOpacity', {
                        id: this.cue.id,
                        lineOpacity: this.cueLineOpacity
                    });
                    this.changeLineOpacityTimer = null;
                }, 500);
            },
            getTitleFontSize(layer) {
                const layers = this.userProjectData.layers;
                if (layers && layers[layer.id]) {
                    if (layers[layer.id].titleFontSize) {
                        return layers[layer.id].titleFontSize;
                    }
                }
                return 14;
            },
            getLineOpacity(layer) {
                const layers = this.userProjectData.layers;
                if (layers && layers[layer.id]) {
                    if (layers[layer.id].lineOpacity) {
                        return layers[layer.id].lineOpacity;
                    }
                }
                return 30;
            },
            getBoxOpacity(layer) {
                const layers = this.userProjectData.layers;
                if (layers && layers[layer.id]) {
                    if (layers[layer.id].boxOpacity) {
                        return layers[layer.id].boxOpacity;
                    }
                }
                return 20;
            },
            restoreDefault() {
                this.cueTitleFontSize = this.getTitleFontSize({id: this.cue.layer});
                this.cueLineOpacity = this.getLineOpacity({id: this.cue.layer});
                delete this.cue.titleFontSize;
                delete this.cue.lineOpacity;
                this.$store.dispatch('removeCueTitleFontSize', {
                    id: this.cue.id
                });
                this.$store.dispatch('removeCueLineOpacity', {
                    id: this.cue.id
                });
                this.$store.dispatch('removeCueProperties', {
                    cue: this.cue,
                    keys: ['titleFontSize', 'lineOpacity']
                });
                this.$store.dispatch('removeCueHeaderBoxOptions', {
                    id: this.cue.id
                });
            },
            restoreDefaultCueMarker() {
                this.cueBoxOpacity = this.getBoxOpacity({id: this.cue.layer});
                delete this.cue.boxOpacity;
                this.$store.dispatch('removeCueBoxOpacity', {
                    id: this.cue.id
                });
                this.$store.dispatch('removeCueProperties', {
                    cue: this.cue,
                    keys: ['boxOpacity']
                });
            },
            changeBoxOpacity() {
                if (this.changeBoxOpacityTimer) {
                    clearTimeout(this.changeBoxOpacityTimer);
                }
                this.changeBoxOpacityTimer = setTimeout(() => {
                    this.$store.dispatch('addCueBoxOpacity', {
                        id: this.cue.id,
                        boxOpacity: this.cueBoxOpacity
                    });
                    this.changeBoxOpacityTimer = null;
                }, 500);
            },
            deleteCueMarker() {
                this.$store.dispatch('deleteCue', this.cue);
            },
            pageDown() {
                if (this.canPageDown) {
                    this.move_cue_to--;
                    this.pageDraft = labelForPage(this.pageLabels, this.move_cue_to);
                    this.pageError = '';
                }
            },
            pageUp() {
                if (this.canPageUp) {
                    this.move_cue_to++;
                    this.pageDraft = labelForPage(this.pageLabels, this.move_cue_to);
                    this.pageError = '';
                }
            },
            changeHeaderBoxTitle() {
                if (this.headerBox.title && !this.headerBox.label) return;
                // Pin ONLY title for this cue; label/time keep following the global default.
                this.$set(this.headerBox, 'title', !this.headerBox.title);
                this.$store.dispatch('addCueHeaderBoxOptions', {
                    id: this.cue.id,
                    title: this.headerBox.title
                });
            },
            changeHeaderBoxLabel() {
                if (!this.headerBox.title && this.headerBox.label) return;
                this.$set(this.headerBox, 'label', !this.headerBox.label);
                this.$store.dispatch('addCueHeaderBoxOptions', {
                    id: this.cue.id,
                    label: this.headerBox.label
                });
            },
            changeHeaderBoxTime() {
                // Time is independent — no "at least one" guard; it can be freely toggled on/off.
                this.$set(this.headerBox, 'time', !this.headerBox.time);
                this.$store.dispatch('addCueHeaderBoxOptions', {
                    id: this.cue.id,
                    time: this.headerBox.time
                });
            },
            changeHeaderBoxLayerName() {
                // Per-cue only; mirrors changeHeaderBoxTitle. Explicit $set (synchronous) +
                // dispatch of the computed value dodges the md-switch @change timing bug.
                // next = new layerName (true=shown): toggling from hidden(false) flips to shown.
                const next = this.headerBox.layerName === false;
                this.$set(this.headerBox, 'layerName', next);
                this.$store.dispatch('addCueHeaderBoxOptions', {
                    id: this.cue.id,
                    layerName: next
                });
            },
            getCurrentCueSize() {
                return this.$props.titleFontSize;
            },
            layerTitleStyle() {
                return {
                    fontSize: this.getCurrentCueSize() + 'px'
                };
            },
            layerTitleIconStyle() {
                const cueSize = this.getCurrentCueSize();
                return {
                    fontSize: cueSize + 'px',
                    width: (cueSize / 2) + 'px',
                    height: cueSize + 'px',
                    minWidth: (cueSize / 2) + 'px',
                    minHeight: cueSize + 'px',
                    marginLeft: (-cueSize / 4) + 'px'
                };
            },
            menuOffsetStyleX() {
                return -16 * this.selectedScale;
            },
            menuOffsetStyleY() {
                return 2;
            },
            preventContextFunc: function(e) {
                e.preventDefault();
                e.stopPropagation();
                this.$emit('toggle');
                this.$emit('focusWorkNote');
            }
        },
        components: {
            'vue-slider': VueSlider
        }
    };
    
    export default ProjectCuesLayerPicker;
    </script>
    
    <style lang="scss">
    .md-menu-content {
        .cue-size, .cue-marker, .visible-in-cue {
            margin-top: 10px;
        }
    }
    .md-list-item .md-list-item-container {
        min-height: auto;
        font-size: 16px;
    }
    .md-list-item {
        &.change-page {
            margin: 0px -10px 2px 2px;

            // The "No page ..." line sits on its own row under the box.
            .md-list-item-content {
                flex-wrap: wrap;
            }
            .page-number-error {
                flex-basis: 100%;
            }
    
            .change-page-done.md-button.md-icon-button {
                width: auto;
                border-radius: 6px;
                padding: 8px 8px;
                height: auto;
                margin-left: 6px;
                line-height: normal;
                min-height: unset;
                font-size: 12px;
                text-transform: capitalize;
            }
        }
    
        hr {
            margin: 2px;
        }
    }
    .ql-cue-layer-picker-content {
        display: flex;
        > .md-menu {
            display: flex;
        }
    }
    .ql-cue-layer-picker {
        min-height: 32px; 
        min-width: 32px;
        margin: 0;
        border-radius: 0;
        .ql-cue-layer-picker {
            min-width: 32px;
            min-height: 32px;
        }
    }
    .ql-cue-layer-picker-button {
        margin: 0;
        padding: 0;
        min-width: 0;
        line-height: 100%;
        min-height: 0;
        display: flex;
        align-items: center;
        .md-icon {
            color: #999;
            margin-right: 4px;
            // width: 12px;
            // min-width: 12px;
            // position: absolute;
            // left: -6px;
            // top: 50%;
            // transform: translateY(-50%);
        }
        span {
            line-height: 1.1;
            display: block;
            display: inline-block;
            width: auto;
            max-width: 130px;
            white-space: nowrap;
            overflow: hidden !important;
            text-overflow: ellipsis;
        }
    }
    // With the name hidden, the trigger is the whole clickable ⋮ area. The dead ~17px
    // separator that used to follow it is removed (see cue-header `v-if` on the separator),
    // so this padding IS the entire ⋮ space and all of it opens the menu. Horizontal only —
    // a taller button shifted/clipped the number/label. Modest: bigger than the bare dots.
    .ql-cue-layer-picker-button.name-hidden {
        padding-right: 5px;
        cursor: pointer;
    }
    .ql-cue-layer-picker-option {
        margin-left: 12px;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .ql-cue-layer-picker-wrapper {
        .ql-cue-layer-picker {
            min-width: 32px;
            min-height: 32px;
        }
    }
    .input_page_number {
        width: 40px;
        text-align: center;
    }
    .page-number-error {
        display: block;
        margin-top: 4px;
        color: #c0392b;
        font-size: 12px;
        line-height: 1.3;
        white-space: normal;
    }
    .headerBoxOption {
        &.headerBoxOptionMarked {
            i {
                color: #5ecfdf !important;
            }
        }
    }
    .md-list-item-content {
        flex: 1;
    }
    .ql-cue-menu-content {
        width: auto;
        max-width: -webkit-fill-available;
    
        .page-number-container {
            flex: 1;
            text-align: center;
        }
    }
    .ql-cue-menu-list-item-content {
        .md-list-item-radio-options {
            margin-top: 12px;
            margin-bottom: 8px;
        }
        .md-radio {
            margin: 0 0 8px;
        }
    }
    </style>


// WEBPACK FOOTER //
// layer-picker.vue?59c40737